import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_status_change_tasksService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotIds?: number[], materialIds?: number[], licensePlateIds?: number[], locationIds?: number[], taskIds?: number[], chainHeads?: number[], serialNumberIds?: number[], operationTypeId: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ChainHead?: number, CompletedDateTime?: string, LotId?: number, MaterialId?: number, OperationCodeId?: number, ReasonCodeId?: number, SerialNumberId?: number, OperationCode?: { Name?: string, OperationTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationTypeId)) {
      missingRequiredInParams.push('\'operationTypeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotIds?: number[], materialIds?: number[], licensePlateIds?: number[], locationIds?: number[], taskIds?: number[], chainHeads?: number[], serialNumberIds?: number[], operationTypeId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ChainHead?: number, CompletedDateTime?: string, LotId?: number, MaterialId?: number, OperationCodeId?: number, ReasonCodeId?: number, SerialNumberId?: number, OperationCode?: { Name?: string, OperationTypeId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationTypeId)) {
      missingRequiredInParams.push('\'operationTypeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotIds?: number[], materialIds?: number[], licensePlateIds?: number[], locationIds?: number[], taskIds?: number[], chainHeads?: number[], serialNumberIds?: number[], operationTypeId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ChainHead?: number, CompletedDateTime?: string, LotId?: number, MaterialId?: number, OperationCodeId?: number, ReasonCodeId?: number, SerialNumberId?: number, OperationCode?: { Name?: string, OperationTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationTypeId)) {
      missingRequiredInParams.push('\'operationTypeId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotIds?: number[], materialIds?: number[], licensePlateIds?: number[], locationIds?: number[], taskIds?: number[], chainHeads?: number[], serialNumberIds?: number[], operationTypeId: number    }) {
        if(isNil(inParams.operationTypeId)) {
          return true; 
        }
      return false;
    }
}
